export const handleKnobVibratoChangeInternal = (
  knobValue: number,
  knobValueWas: number,
  pitches: number[],
  diffs: number[]
) =>
  // undo the previous changes before applying the new ones
  pitches.map(
    (pitch, i) =>
      pitch + diffs[i] * (knobValueWas / 100) - diffs[i] * (knobValue / 100)
  );
